import classNames from 'classnames';
import { ReactNode } from 'react';
import './style.scss';

export type CheckboxProps = {
  label: ReactNode;
  dataTestId: string;
  headline?: ReactNode;
  value: boolean;
  onChange: (value: boolean) => void;
  className?: string;
};

const Checkbox = ({ label, headline, value, onChange, className, dataTestId }: CheckboxProps) => (
  <div className={classNames('checkbox-input', className)} onClick={() => onChange?.(!value)}>
    <input
      type="checkbox"
      onChange={e => onChange?.(e.currentTarget.checked)}
      checked={value}
      className="checkbox-input__checkbox"
      data-test-id={dataTestId}
    />
    <div className="checkbox-input__label">
      {headline && <div className="checkbox-input__headline">{headline}</div>}
      <div>{label}</div>
    </div>
  </div>
);

export default Checkbox;
